// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.thirdDiv .this_a_blank {\n    pointer-events: none !important;\n    padding-left: 25px !important;\n    box-sizing: border-box;\n}\n.thirdDiv input::-webkit-input-placeholder {\n    color: red;\n    font-weight: 700;\n    font-size: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
